<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <media-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import MediaTable from "./components/MediaTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    MediaTable,
    // ProjectsTable,
  },
};
</script>
